<template>
  <div>
    <div class="section-header">
      <div class="section-headers">Courses</div>
      <router-link :to="{name: 'newCourse'}">New Course</router-link>
    </div>
    <div class="row flex-wrap">
      <course-card 
        v-for="(course, i) in courses" 
        :key="course.id" 
        :course="course" 
        :loading="saving"
        @move="(direction) => move(course, i, direction)"
        :img="backgroundImg(course, i)"
        @click="$router.push({name: 'CoachCourseDetail', params: {id: course.id}})"/>
    </div>
  </div>
</template>

<script>
import dataStore from "@/services/api/store";
import courseCard from "./courseCard";
const COURSE_STORE = "CoachCourses";

export default {
  components: { courseCard },
  data() {
    return {
      courses: [],
      saving: false
    };
  },
  created() {
    dataStore.findAll(COURSE_STORE, {}, { force: true }).then(result => {
      this.courses = result;
    });
  },
  methods: {
    move(course, index, direction) {
      const nextLocation = index + direction;
      if (nextLocation < 0 || nextLocation >= this.courses.length) {
        return;
      }
      this.saving = true;

      const switchingWith = this.courses[nextLocation];
      this.courses[nextLocation] = course;
      this.courses[index] = switchingWith;
      switchingWith.ordering = index;
      course.ordering = nextLocation;

      let first = switchingWith.save();
      let second = course.save();
      Promise.all([first, second]).finally(() => {
        this.saving = false;
      });
    },
    backgroundImg(course, i) {
      let images = ['mountains.jpeg', 'butterflys.jpeg', 'fall.jpeg', 'flowers.jpeg', 'thunder.jpeg', 'trees.jpg'];
      let image = "";
      if (!course.background_image) {
        image = "/img/" + images[i % images.length];
      } else {
        image = course.background_image;
      }
      return image;
    }
  }
};
</script>

<style>
.course-description {
  font-size: 14px;
  letter-spacing: 1px;
  padding-top: 8px;
  padding-bottom: 8px;
}
</style>
